import {
  email,
  min,
  max,
  required,
  digits,
  numeric,
  between,
  integer,
  // eslint-disable-next-line
  min_value
} from 'vee-validate/dist/rules'
import {
  extend,
  ValidationProvider,
  ValidationObserver,
  setInteractionMode
} from 'vee-validate'

setInteractionMode('eager')

extend('selection', {
  ...required,
  message: '選択してください'
})

extend('required', {
  ...required,
  message: '入力してください'
})

extend('min', {
  ...min,
  message: '{length}文字以上で入力してください'
})

extend('max', {
  ...max,
  message: '{length}文字以下で入力してください'
})

extend('email', {
  ...email,
  message: 'メールアドレスに誤りがあります'
})

extend('selectInput', {
  ...required,
  message: '選択、または入力してください'
})

extend('digits', {
  ...digits,
  message: '数字で入力してください'
})
extend('numeric', {
  ...numeric,
  message: '数字で入力してください'
})
extend('between', {
  ...between,
  message: '{min}から{max}までの数字で入力してください'
})
extend('integer', {
  ...integer,
  message: '整数で入力してください'
})
extend('min_value', {
  // eslint-disable-next-line
  ...min_value,
  message: '{min}以上で入力してください'
})

export const ValidateProvider = ValidationProvider
export const ValidateObserver = ValidationObserver
